// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"be8d0ebf","344":"c66eefad","453":"a04ae9d0","455":"243aa323","666":"77f3e460","977":"5c4f4419"}[chunkId] + ".chunk.js";
};